import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { AuthState } from './auth.types'
import { removeGuestToken } from 'lib/services/api/getAccessToken'
import { sendFlushCommandToIframes } from 'lib/utils/iframeUtils'

export const useAuthStore = create<AuthState>()(
  devtools(
    (set, get) => ({
      // Actions
      handleLogout: (logoutFn: () => void) => {
        setTimeout(() => {
          logoutFn()
          removeGuestToken()
          sendFlushCommandToIframes()
        }, 200)
      },
    }),
    {
      name: 'auth-store',
    }
  )
)

// Action hooks
export const useAuthActions = () => {
  const store = useAuthStore()
  return {
    handleLogout: store.handleLogout,
  }
}
